import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-steps-header',
	templateUrl: './steps-header.component.html',
	styleUrls: ['./steps-header.component.scss'],
})
export class StepsHeaderComponent implements OnInit {
	ngOnInit(): void {
		//no content
	}
}
